export default "__VITE_ASSET__BF18HurQ__"